import * as z from 'zod';

export const inventoryKitQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string().min(3),
});

export type InventoryKitQueryLinkerSchema = z.infer<typeof inventoryKitQueryLinkerSchema>;
